import { Button } from '@/shared/components/Buttons';
import { Snackbar } from '@/shared/components/Snackbar';
import AddUserModal from '@/shared/layout/createLayout/CreateModal';
import { CreateLayoutProps } from '../types';

const CreateLayout = ({
  isSubmitting,
  handleSubmit,
  handleCancel,
  isCancelModalOpen,
  handleCloseCancelModal,
  handleConfirmCancel,
  isSnackbarOpen,
  handleCloseSnackbar,
  snackbarError,
  isSuccessSnackbarOpen,
  handleCloseSuccessSnackbar,
  snackbarSuccess,
  children,
  Header,
  cancelButtonLabel = 'Anuluj',
  submitButtonLabel = 'Dodaj administratora',
  submitButtonLoadingLabel = 'Dodawanie administratora...',
  submitButtonDisabled,
  cancelButtonDisabled,
  headerClassName,
}: CreateLayoutProps) => {
  return (
    <div className="relative w-[100%] h-[100%] overflow-hidden">
      <form
        onSubmit={handleSubmit}
        className="bg-white w-[100%] h-[100%] px-4 pt-4 flex flex-col overflow-hidden rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]"
      >
        <div className={headerClassName ?? 'mb-7 py-[10px] pr-4'}>
          <Header />
        </div>
        <div className="flex flex-col gap-8 overflow-auto custom-scrollbar pb-[120px] px-4 -mx-4 flex-1 min-h-0">
          {children}
          <div
            className="flex fixed bottom-0 max-h-[64px] justify-end gap-[16px] bg-[#FAFAFA] rounded-[20px] px-3 py-3 z-10 mt-auto mb-10"
            style={{
              left: 'calc(var(--sidebar-width) + 30px)',
              right: '30px',
              boxShadow:
                '0px 2px 8px 0px #00000014, 0px 6px 12px 4px #0000000A, 0px -2px 8px 0px #00000014',
            }}
          >
            <Button
              label={cancelButtonLabel}
              buttonType="Square"
              type="button"
              onClick={handleCancel}
              style={{ height: '40px' }}
              className={
                (cancelButtonDisabled ?? isSubmitting)
                  ? '!h-[40px] border border-[#181A1B]/[0.12] !text-labelLarge !rounded-[8px] !cursor-not-allowed opacity-60'
                  : '!bg-transparent !h-[40px] cursor-pointer border border-[#DCDDE0] !text-labelLarge !text-on-surface-variant hover:!border-[#DCDDE0] hover:!bg-[#474A4C]/[0.08] !rounded-[8px]'
              }
              disabled={cancelButtonDisabled ?? isSubmitting}
            />
            <Button
              label={
                isSubmitting ? submitButtonLoadingLabel : submitButtonLabel
              }
              type="submit"
              disabled={submitButtonDisabled ?? isSubmitting}
              style={{ height: '40px' }}
              className="!h-[40px] text-labelLarge cursor-pointer !rounded-[8px]"
            />
          </div>
        </div>
      </form>

      {/* Error Snackbar */}
      <Snackbar
        open={isSnackbarOpen}
        message={snackbarError}
        variant="error"
        onClose={handleCloseSnackbar}
        autoHideDuration={5000}
        position="top-center"
        showCloseButton={true}
      />
      {/* Success Snackbar */}
      <Snackbar
        open={isSuccessSnackbarOpen ?? false}
        message={snackbarSuccess ?? ''}
        variant="success"
        onClose={handleCloseSuccessSnackbar}
        autoHideDuration={10000}
        position="top-center"
        showCloseButton={true}
      />
      {/* Cancel Confirmation Modal */}
      <AddUserModal
        open={isCancelModalOpen}
        onClose={handleCloseCancelModal}
        onConfirmCancel={handleConfirmCancel}
      />
    </div>
  );
};
export default CreateLayout;
